/* eslint-disable global-require */
import React, { useContext, useEffect, useState } from 'react'
import ImageGallery, { GalleryItem } from 'react-image-gallery'
import { useIntl } from 'react-intl'
import 'react-image-gallery/styles/image-gallery.css'

// styles
import * as SC from './GalleryMobileStyles'

// types
import { Image as ImageType } from '../../../../types/types'

// utils
import { AppContext } from '../../../../utils/appProvider'
import { checkWebPSupport } from '../../../../utils/helper'
import { useIsAnyModalOpen } from '../../../../atoms/Modal/ModalOpenContext'

type Props = {
	images: ImageType[]
}

const GalleryMobile = (props: Props) => {
	const { images } = props

	const { assetsPath } = useContext(AppContext)
	const { formatMessage } = useIntl()
	const isAnyModalOpen = useIsAnyModalOpen()

	const [isLoading, setIsLoading] = useState(true)

	const placeholderSmall = `${assetsPath}/${require('../../../../assets/images/basic-salon-placeholder-small.jpg')}`
	const placeholderSmallWebP = `${assetsPath}/${require('../../../../assets/images/basic-salon-placeholder-small.webp')}`

	const totalCount = images.length

	const sliderImages: GalleryItem[] = images?.map((image, index) => {
		return {
			original: image.resizedImages.small,
			loading: 'lazy',
			originalAlt: formatMessage({ id: 'Photo {index} of {total}', defaultMessage: 'Photo {index} of {total}' }, { index: index + 1, total: totalCount }),
			srcSet: `
                ${image.resizedImages.small} 480w,
                ${image.resizedImages.medium} 1080w,
                ${image.resizedImages.large} 1500w
            `,
			sizes: `
                (max-width: 480px) 480px,
                (max-width: 1080px) 1080px,
                1500px
            `
		}
	})

	// add placeholder if salon doesn't have any images
	if (sliderImages.length <= 0) {
		sliderImages.push({
			original: `${assetsPath}/${require('../../../../assets/images/basic-salon-placeholder.jpg')}`,
			originalAlt: ''
		})
	}

	useEffect(() => {
		const checkImageLoaded = () => {
			const img = new Image()
			img.src = checkWebPSupport() && placeholderSmallWebP ? placeholderSmallWebP : placeholderSmall
			img.onload = () => setIsLoading(false)
			img.onerror = () => setIsLoading(false)
		}

		checkImageLoaded()
	}, [placeholderSmall, placeholderSmallWebP])

	return (
		<SC.GalleryMobileContainer>
			{isLoading ? (
				<picture>
					<source srcSet={placeholderSmallWebP} type='image/webp' />
					<SC.SingleImage src={placeholderSmall} alt={''} loading={'eager'} />
				</picture>
			) : (
				<ImageGallery
					lazyLoad={true}
					items={sliderImages}
					showNav={false}
					showPlayButton={false}
					showThumbnails={false}
					showFullscreenButton={false}
					showBullets
					disableKeyDown={isAnyModalOpen}
				/>
			)}
		</SC.GalleryMobileContainer>
	)
}

export default GalleryMobile
